/* eslint-disable max-statements */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
/* eslint-disable complexity */
import CardWrapper from '../wrapper/card';
import CustomInput from '../reusable/input';
import DeleteFileModal from './modal/delete_file';
import { fetchClientTaskThunk } from '../../redux/thunks/task';
import { FileObject } from '../../params/redux/file';
import { gray } from '../../theme/themePrimitives';
import ImageClass from '../../assets';
import RemoveAssigneeModal from './modal/remove_assignee';
import RemoveCommentModal from './modal/comment_removal';
import RemoveTaskModal from './modal/task_removal';
import TaskSelectorModal from './modal/assign_task';
import { useParams } from 'react-router';
import { addFileCommentThunk, editFileNameThunk, editWordDocumentThunk, fetchSingleFileDetailsThunk } from '../../redux/thunks/file';
import { AppDispatch, RootState } from '../../redux/store';
import { Avatar, Box, Button, Divider, IconButton, Typography } from '@mui/material';
import { ChatBubbleOutlineOutlined, DeleteOutlineOutlined, DocumentScannerOutlined, EditOutlined, FileCopy, PostAddOutlined } from '@mui/icons-material';
import { formatDateWithTime, formatTimeUptoNow } from '../../helper';
import { settingSelectedFile, settingSelectedFileDetail } from '../../redux/slices/file';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

import 'react-quill/dist/quill.snow.css';

const EditFileComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [commentValue, setCommentValue] = useState<string>('');
    const [, setAnchorEl] = useState<null | HTMLElement>(null);
    const [taskModal, setTaskModal] = useState<boolean>(false);
    const { selectedFile, selectedFileDetail } = useSelector((state: RootState) => state.file);
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const { loaders } = useSelector((state: RootState) => state.task);
    const [deleteFile, setDeleteFile] = useState<boolean>(false);
    const [editFile, setEditFile] = useState<boolean>(false);
    const [commentModal, setCommentModal] = useState<number | null>(null);
    const [taskRemoveModal, setTaskRemoveModal] = useState<number | null>(null);
    const [removeAssigneeModal, setRemoveAssigneeModal] = useState<number | null>(null);
    const [fileName, setFileName] = useState<string>(selectedFileDetail?.file_name || '');
    const [editFileDoc, setEditFileDoc] = useState<string>(selectedFileDetail?.html || '');

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    });

    useEffect(() => {
        if (selectedFileDetail?.html) {
            setEditFileDoc(selectedFileDetail.html);
        }
    }, [selectedFileDetail?.html]);

    // const handleFileOpen = (e: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(e.currentTarget);
    // };

    // const handleAddAssignee = async (newAssigneeId: number) => {
    //     try {
    //         const dataForApi: AssignFileParams = {
    //             file_id: selectedFileDetail?.id || 0,
    //             user_id: newAssigneeId,
    //             client_id: id ? parseInt(id as string, 10) : 0
    //         };
    //         await dispatch(assignFileThunk(dataForApi)).unwrap();
    //     } catch (e) {
    //         //
    //     }
    // };

    const fetchBoardDetails = async () => {
        try {
            await dispatch(fetchClientTaskThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            setTaskModal(true);
        } catch (e) {
            //
        }
    };

    const addCommentHandler = async () => {
        try {
            await dispatch(addFileCommentThunk(commentValue)).unwrap();
            setCommentValue('');
            await dispatch(fetchSingleFileDetailsThunk()).unwrap();
        } catch {
            //
        }
    };

    const removeCommentHandler = (comment_id: number) => {
        setCommentModal(comment_id);
    };

    const handleDeleteTask = (task_id: number) => {
        setTaskRemoveModal(task_id);
    };

    const handleCloseModal = (event?: React.MouseEvent<HTMLButtonElement>) => {
        if (event) event.stopPropagation();
        setDeleteFile(false);
    };

    // const removeAssigneeHandler = (assignee_id: number) => {
    //     setRemoveAssigneeModal(assignee_id);
    // };

    const onSubmitHandler = async () => {
        // const cleanBody = editFileDoc.replace(/<(?:.|\n)*?>/gu, '').trim();
        // if (cleanBody) {
        try {
            if (selectedFile?.file_type === 'internal') {
                await dispatch(editWordDocumentThunk({
                    html: editFileDoc,
                    file_name: fileName
                })).unwrap();
            } else {
                await dispatch(editFileNameThunk({ file_name: fileName, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
            }
        } catch (e) {
            //
        }
        // } else {
        //     toast.error('Please enter a message.', {
        //         position: 'top-left',
        //         autoClose: 5000,
        //         theme: 'dark'
        //     });
        // }
    };

    const handleFileView = () => {
        if (!deleteFile) {
            window.open(`${process.env.REACT_APP_FILE_PATH}${selectedFileDetail?.file_path}`, '_blank');
        }
    };

    const editFileHandler = () => {
        setFileName(selectedFileDetail?.file_name as string);
        setEditFileDoc(selectedFileDetail?.html as string);
        setEditFile(true);
    };

    const handleNavgiateBack = () => {
        dispatch(settingSelectedFile(null));
        dispatch(settingSelectedFileDetail(null));
        setFileName('');
        setEditFileDoc('');
        setAnchorEl(null);
        setTaskModal(false);
        setDeleteFile(false);
        setEditFile(false);
    };

    const resetDetails = () => {
        setEditFileDoc('');
        setAnchorEl(null);
        setTaskModal(false);
        setDeleteFile(false);
        setEditFile(false);
    };

    return (
        <Box borderTop={`1px solid ${gray[100]}`} pt={1} >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Button variant="text" color="secondary" disabled={loaders.isCreating || loaders.isUpdating} onClick={handleNavgiateBack}>&larr; Back</Button>
                {
                    editFile
                        ? <Box>
                            <CustomInput
                                // fullWidth
                                // label="Product Name"
                                name="file_name"
                                placeholder="Type here"
                                value={fileName}
                                onChange={(e) => setFileName(e.target.value)}
                                disabled={loaders.isCreating || loaders.isUpdating}
                            />
                        </Box>
                        : <Typography variant="h5" color="info">{selectedFileDetail?.file_name}</Typography>
                }
                {
                    editFile
                        ? <Box display="flex" gap={2}>
                            <Button variant="outlined" size="large" color="secondary" disabled={loaders.isCreating || loaders.isUpdating} onClick={resetDetails}>Cancel</Button>
                            <Button variant="contained" size="large" disabled={loaders.isCreating || loaders.isUpdating} onClick={onSubmitHandler}>Save Changes</Button>
                        </Box>
                        : <Box display="flex">
                            <IconButton color="primary" disabled={loaders.isCreating || loaders.isUpdating} onClick={editFileHandler}>
                                <EditOutlined />
                            </IconButton>
                            <IconButton color="error" disabled={loaders.isCreating || loaders.isUpdating} onClick={() => setDeleteFile(true)}>
                                <DeleteOutlineOutlined />
                            </IconButton>
                        </Box>
                }
            </Box>
            {(editFile && selectedFileDetail?.file_type === 'internal') && (
                <Box className="text-editor" width="100%" height="30vh" mt={2}>
                    <CustomInput
                        type="quill"
                        value={editFileDoc}
                        name="filedoc"
                        placeholder="Type content here..."
                        quillHeight="22vh"
                        disabled={loaders.isCreating || loaders.isUpdating}
                        onChangeForPhone={(value: string) => setEditFileDoc(value)}
                    />
                    {/* <CustomToolbar />
                    <ReactQuill
                        onChange={(content) => setEditFileDoc(content)}
                        value={editFileDoc}
                        placeholder="Type content here..."
                        modules={quillModule}
                        formats={quillFormats}
                        theme="snow"
                        readOnly={loaders.isCreating}
                        style={{
                            height: '22vh',
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px'
                            // border: editFileDoc.replace(/<(?:.|\n)*?>/gu, '').trim() ? 'none' : `1px solid ${red[300]}`
                        }}
                    /> */}
                </Box>
            )}
            {(!editFile && selectedFileDetail?.file_type === 'internal') && (
                <Box mt={2} className="gonzy-email-body" dangerouslySetInnerHTML={{ __html: selectedFileDetail?.innerHtml }}>
                </Box>
            )}
            <Typography variant="body1" color="textDisabled" gutterBottom>Created {selectedFileDetail?.created_at && formatTimeUptoNow(selectedFileDetail.created_at)}  .  Last Modified {selectedFileDetail?.updated_at && formatTimeUptoNow(selectedFileDetail.updated_at)}</Typography>
            <Divider />
            <Box display="flex" gap="10px" mt={2}>
                <CardWrapper>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap="10px"><FileCopy /><Typography variant="h6" color="textSecondary"> File Info</Typography></Box>
                    </Box>
                    <Box display="flex" flexDirection="column" gap="20px" minHeight="35vh" maxHeight="35vh" overflow="auto" pt={1}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{
                            '&:hover': {
                                cursor: 'pointer'
                            }
                        }} onClick={handleFileView}>
                            <Box display="flex" alignItems="center" gap="10px">
                                <Box
                                    maxHeight="3vh"
                                    minHeight="4vh"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    px={2}
                                    sx={{
                                        borderTopLeftRadius: '10px',
                                        borderTopRightRadius: '10px'
                                    }}>
                                    <img
                                        alt={selectedFileDetail?.file_name}
                                        src={['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'tiff'].includes(selectedFileDetail?.extension || '') ? `${process.env.REACT_APP_FILE_PATH}${selectedFileDetail?.file_path || ''}` : ImageClass.document}
                                        style={{
                                            width: '100%',
                                            height: '4vh',
                                            objectFit: 'contain'
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Typography variant="subtitle1" color="info">{selectedFileDetail?.file_name}</Typography>
                                    <Typography variant="subtitle2" color="textDisabled">{selectedFileDetail?.formatted_size}</Typography>
                                </Box>
                            </Box>
                            <Box>
                                {selectedFileDetail?.created_at && formatTimeUptoNow(selectedFileDetail.created_at)}
                            </Box>
                        </Box>
                    </Box>
                </CardWrapper>
                {/* <CardWrapper>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap="10px"><Person2Outlined /><Typography variant="h6" color="textSecondary"> Contributors</Typography></Box>
                        <Button variant="outlined" disabled={loaders.isCreating || loaders.isUpdating} onClick={handleFileOpen} startIcon={<PersonAddAlt1Outlined />}>Assign Users</Button>
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={() => setAnchorEl(null)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        >
                            <Box p={2} width="250px">
                                {customers.filter((customer) => (customer.id !== currentUser?.id && customer.is_primary !== 1 && !selectedFileDetail?.assigned_users?.some((user) => user.id === customer.id))).map((member) => (
                                    <Box
                                        key={member.id}
                                        display="flex"
                                        flexDirection="column"
                                        gap={1}
                                    >
                                        <Button fullWidth variant="text" disabled={loaders.isCreating || loaders.isUpdating} onClick={() => handleAddAssignee(member.id)}>{member.first_name} {member.last_name}</Button>
                                    </Box>
                                ))}
                            </Box>
                        </Popover>
                    </Box>
                    <Box display="flex" flexDirection="column" justifyContent={selectedFileDetail?.assigned_users.length === 0 ? 'center' : 'start'} gap="20px" minHeight="35vh" maxHeight="35vh" overflow="auto" pt={1}>
                        {
                            selectedFileDetail?.assigned_users.length === 0
                                ? <Typography variant="subtitle1" fontWeight="bold" color="textDisabled" align="center">No User Assigned</Typography>
                                : selectedFileDetail?.assigned_users?.map((user, index) => <Box key={index}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box display="flex" gap={2} alignItems="center">
                                            <Avatar alt={user.first_name} sx={{
                                                height: 35,
                                                width: 35,
                                                bgcolor: gray[300]
                                            }}></Avatar>
                                            <Box>
                                                <Typography variant="subtitle1" color="textDisabled" fontWeight="bold">{`${user.first_name} ${user.last_name}`}</Typography>
                                                <Typography variant="body2">{formatTimeUptoNow(user.created_at)}</Typography>
                                            </Box>
                                        </Box>
                                        <Button variant="text" color="error" disabled={loaders.isCreating || loaders.isUpdating} onClick={() => removeAssigneeHandler(user.id)}>Remove</Button>
                                    </Box>
                                </Box>)
                        }
                    </Box>
                </CardWrapper> */}
                <CardWrapper>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap="10px"><DocumentScannerOutlined /><Typography variant="h6" color="textSecondary"> Tasks</Typography></Box>
                        <Button variant="outlined" onClick={fetchBoardDetails} disabled={loaders.isCreating || loaders.isUpdating} startIcon={<PostAddOutlined />}>Assign Tasks</Button>
                    </Box>
                    <Box display="flex" flexDirection="column" minHeight="35vh" maxHeight="35vh" overflow="auto" justifyContent={selectedFileDetail?.assigned_tasks.length === 0 ? 'center' : 'flex-start'} gap="20px">
                        {
                            selectedFileDetail?.assigned_tasks.length === 0
                                ? <Typography variant="subtitle1" fontWeight="bold" color="textDisabled" align="center">No Task Assigned</Typography>
                                : selectedFileDetail?.assigned_tasks?.map((task, index) => <Box key={index}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography variant="subtitle1" color="textSecondary" fontWeight="bold" >{task.title}</Typography>
                                        <IconButton size="medium" color="error" disabled={loaders.isCreating || loaders.isUpdating} onClick={() => handleDeleteTask(task.id)}><DeleteOutlineOutlined /></IconButton>
                                    </Box>
                                    <Typography variant="subtitle2" color="textDisabled" fontWeight="bold" >{task.description}</Typography>
                                    <Typography variant="subtitle2" color="textDisabled" fontWeight="bold" >{formatDateWithTime(task.due_date)}</Typography>
                                </Box>)}
                    </Box>
                </CardWrapper>
                <CardWrapper>
                    <Box display="flex" alignItems="center" mb={1} gap="10px" ><ChatBubbleOutlineOutlined /><Typography variant="h6" color="textSecondary"> Comments</Typography></Box>
                    <CardWrapper>
                        <Box display="flex" flexDirection="column" minHeight="35vh" maxHeight="35vh" overflow="auto" gap="20px" pt={1}>
                            {
                                selectedFileDetail?.comments.length === 0
                                    ? <Typography variant="subtitle1" fontWeight="bold" color="textDisabled" align="center">No Comments Added</Typography>
                                    : selectedFileDetail?.comments?.map((comment, index) => <Box key={index}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Box display="flex" gap={2} alignItems="center">
                                                <Avatar alt={comment.comment} sx={{
                                                    height: 35,
                                                    width: 35,
                                                    bgcolor: gray[300]
                                                }}></Avatar>
                                                <Box>
                                                    <Typography variant="subtitle1" color="textSecondary">{comment.comment}</Typography>
                                                    {comment?.user && <Typography variant="body2" fontSize="12px" color="textSecondary">Added by: <b>{`${comment?.user?.first_name || ''} ${comment?.user?.last_name || ''}`}</b> ({comment?.user?.role})</Typography>}
                                                </Box>
                                            </Box>
                                            <IconButton size="medium" color="error" disabled={loaders.isCreating || loaders.isUpdating} onClick={() => removeCommentHandler(comment.id)}><DeleteOutlineOutlined /></IconButton>
                                        </Box>
                                    </Box>)
                            }
                            <div ref={messagesEndRef} />
                        </Box>
                    </CardWrapper>
                    <Box display="flex" alignItems="center" gap="10px" mt={1}>
                        <CustomInput
                            fullWidth
                            value={commentValue}
                            onChange={(e) => setCommentValue(e.target.value)}
                            disabled={loaders.isCreating || loaders.isUpdating}
                            placeholder="Add a comment"
                        />
                        <Button variant="contained" disabled={commentValue.trim() === '' || loaders.isCreating || loaders.isUpdating} onClick={addCommentHandler}>
                            Send
                        </Button>
                    </Box>
                </CardWrapper>
            </Box>
            {taskModal && <TaskSelectorModal open={taskModal} onClose={() => setTaskModal(false)} />}
            {deleteFile && <DeleteFileModal open={deleteFile} onClose={handleCloseModal} file={selectedFile as FileObject} />}
            {taskRemoveModal && <RemoveTaskModal open={Boolean(taskRemoveModal)} onClose={() => setTaskRemoveModal(null)} task_id={taskRemoveModal as number} />}
            {commentModal && <RemoveCommentModal open={Boolean(commentModal)} onClose={() => setCommentModal(null)} comment_id={commentModal as number} />}
            {removeAssigneeModal && <RemoveAssigneeModal open={Boolean(removeAssigneeModal)} onClose={() => setRemoveAssigneeModal(null)} assignee_id={removeAssigneeModal as number} />}
        </Box>
    );
};

export default EditFileComponent;